import { render, staticRenderFns } from "./ReviewCardImages.vue?vue&type=template&id=2da94adc&scoped=true&"
import script from "./ReviewCardImages.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardImages.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardImages.vue?vue&type=style&index=0&id=2da94adc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da94adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da94adc')) {
      api.createRecord('2da94adc', component.options)
    } else {
      api.reload('2da94adc', component.options)
    }
    module.hot.accept("./ReviewCardImages.vue?vue&type=template&id=2da94adc&scoped=true&", function () {
      api.rerender('2da94adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardImages.vue"
export default component.exports